import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from '../../environments/environment';
import { CommonSharedModule } from '../common/shared.module';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [],
  imports: [CommonSharedModule, RouterModule],
  standalone: true
})
export class DashboardComponent {
  onNavigatePartnerDash() {
    window.open(
      'https://pmoosmosis.azurewebsites.net/#/partner-dashboard',
      '_blank'
    );
  }
  onNavigateCustomerUsa() {
    window.open(
      'https://pmoosmosis.azurewebsites.net/#/customer-usage',
      '_blank'
    );
  }

  get isProdEnvironment(): boolean {
    return environment.isProdEnvironment;
  }
}
